import script from "./FirstPageReservationList.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstPageReservationList.vue?vue&type=script&setup=true&lang=js"

import "./FirstPageReservationList.vue?vue&type=style&index=0&id=10743cda&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10743cda"]])

export default __exports__